export function random (min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

/**
 * Randomize array element order in-place.
 * Using Durstenfeld shuffle algorithm.
 */
export const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1))
    let temp = array[i]
    array[i] = array[j]
    array[j] = temp
  }
  return array
}

export const baseURL = process.env.NODE_ENV === 'production' ? 
  'https://api.pennylender.com/api/' : 'https://api.pennylender.com/api/';

export const URL = process.env.NODE_ENV === 'production' ? 
  'https://api.pennylender.com/' : 'https://api.pennylender.com/';
